











































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { AddChargeAccountModel } from '@/models/accounting/accountreceivable';
import { VHeaders, PaginationModel } from '@/models/pagedlistmodel';
import { Base } from '@/components/common/base';
import { IDialogOption } from '@/models/dialog';
import { getAccountHeaders } from '@/views/admin/accounts/account';
import { accountReceivableService } from '@/shared';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
  components: {
    Grid: () => import('@/components/common/app.grid.vue'),
    Stores: () => import('@/components/common/store.select.vue'),
    AppDialog: () => import('@/components/common/app.dialog.vue'),
  },
})
export default class AccountChargeCustomerPage extends Base {
  public headers: VHeaders[] = getAccountHeaders(this);
  public pagedAccounts: AddChargeAccountModel[] = [];
  public pagination = new PaginationModel('name');
  public selectedStore: number = 0;
  public accounts: AddChargeAccountModel[] = [];
  public searched: boolean = true;
  public tenantId: number = 0;
  public enterpriseId: number = 0;
  public storeId: number;
  public loading: boolean = true;
  public deleteDialog: IDialogOption = {
    width: 400,
    title: this.$parent.$t('chargeAccount.deleteDialogTitle') as string,
    model: false,
    action: { color: 'success', icon: 'fas fa-check', text: 'Agree' },
    loading: false,
    onAction: (): void => {
      this.deleteAccount();
    },
  };
  public accountToDelete: AddChargeAccountModel;
  public actions: any[] = [
    {
      type: 'link',
      title: this.$parent.$t(
        'chargeAccount.chargeAccountGridHeaders.gridAction.edit'
      ) as string,
      icon: 'fas fa-edit',
      action: this.generateUrl,
    },
    {
      type: 'button',
      title: this.$parent.$t(
        'chargeAccount.chargeAccountGridHeaders.gridAction.delete'
      ) as string,
      icon: 'fas fa-trash-alt',
      color: 'error',
      action: this.confirmDelete,
    },
  ];

  public created() {
    if (this.$route.params.storeId) {
      this.storeId = Number(this.$route.params.storeId);
    } else {
      this.storeId = this.userSession.storeId;
    }
  }

  public beforeDestroy() {
    const buttons = [];
    this.$emit('updateToolBar', buttons);
  }
  public callMethod(methodName): void {
    if (methodName === 'addAccount') {
      this.$router.push({
        name: 'admin.chargecustomeraccounts.add',
        params: { storeId: this.storeId.toString() },
      });
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: '0',
      type: 'button',
      title: this.$t('chargeAccount.btnAddAccount'),
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$t('chargeAccount.btnAddAccount'),
      click: 'addAccount',
      icon: 'fas fa-plus-circle',
    });
    this.$emit('updateToolBar', buttons);
  }
  public mounted() {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'chargeAccount');
    
    // Toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });

    if (!this.isAuthorizedToAccess(['SuperAdmin', 'T-Admin', 'E-Admin'])) {
      this.getAccountByStore();
    }
  }
  public async getAccountByStore(): Promise<void> {
    this.searched = false;
    try {
      this.loading = true;
      const accounts = await accountReceivableService.getAccountByStoreAsync(
        this.storeId,
        this.pagination
      );
      this.pagedAccounts = accounts.results;
      this.pagination.totalItems = accounts.total;
    } finally {
      this.loading = false;
    }
  }
  public confirmDelete(selected: AddChargeAccountModel): void {
    this.accountToDelete = selected;
    this.deleteDialog.model = true;
  }
  public pageChanged(paging: any) {
    this.pagination = paging;
    this.getAccountByStore();
  }

  public async deleteAccount(): Promise<void> {
    try {
      this.deleteDialog.loading = true;
      await accountReceivableService.deleteChargeCustomerAsync(
        this.accountToDelete.id,
        this.storeId
      );
      this.showAlert(true, this.$t('chargeAccount.alertDeleteChargeAccount'));
      this.deleteDialog.model = false;
      this.getAccountByStore();
    } finally {
      this.deleteDialog.loading = false;
    }
  }
  public generateUrl(props: AddChargeAccountModel): any {
    return {
      name: 'admin.chargecustomeraccounts.edit',
      params: { id: props.id.toString(), storeId: this.storeId },
    };
  }

  public updateStore(storeId: number): void {
    this.storeId = storeId;
    this.getAccountByStore();
    this.searched = false;
  }
}
